import { render, staticRenderFns } from "./NeedHelpToFindLeakageQuestion.vue?vue&type=template&id=56bd60ec&scoped=true"
import script from "./NeedHelpToFindLeakageQuestion.vue?vue&type=script&lang=ts"
export * from "./NeedHelpToFindLeakageQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd60ec",
  null
  
)

export default component.exports